import React, { useState } from 'react';
import { PREFECTURES, getSousPrefectures, getQuartiers } from '../data/guineaGeoData';
import './FilterBar.css';

const ETAT_OPTIONS = [
  { value: 'neuf', label: 'Neuf / récent' },
  { value: 'bon-etat', label: 'Bon état' },
  { value: 'a-renover', label: 'À rénover' },
  { value: 'inacheve', label: 'Inachevé / gros oeuvre' },
];

const TYPE_LOGEMENT_OPTIONS = [
  { value: 'villa', label: 'Villa' },
  { value: 'appartement', label: 'Appartement' },
  { value: 'maison', label: 'Maison' },
  { value: 'duplex', label: 'Duplex' },
  { value: 'studio', label: 'Studio' },
  { value: 'chambre', label: 'Chambre' },
  { value: 'immeuble', label: 'Immeuble' },
];

const TRI_OPTIONS = [
  { value: 'recent', label: 'Plus récentes' },
  { value: 'prix_asc', label: 'Prix croissant' },
  { value: 'prix_desc', label: 'Prix décroissant' },
  { value: 'surface_desc', label: 'Plus grandes surfaces' },
];

const VIDE = {
  type: '',
  typeLogement: '',
  periodeLocation: '',
  ville: '',
  commune: '',
  quartier: '',
  prixMin: '',
  prixMax: '',
  chambresMin: '',
  surfaceMin: '',
  surfaceMax: '',
  surfaceTerrainMin: '',
  surfaceTerrainMax: '',
  etat: '',
  negotiable: '',
  verifie: '',
  photosOnly: '',
  tri: 'recent',
};

export default function FilterBar({ onFiltrer, initialFilters = {} }) {
  const [filtres, setFiltres] = useState({ ...VIDE, ...initialFilters });
  const [ouvert, setOuvert] = useState(false);

  const set = (name) => (e) => {
    const val = e.target.value;
    setFiltres(prev => {
      const next = { ...prev, [name]: val };
      if (name === 'ville') {
        next.commune = '';
        next.quartier = '';
      }
      if (name === 'commune') next.quartier = '';
      if (name === 'type' && val === 'terrain') next.typeLogement = '';
      if (name === 'type' && val !== 'location') next.periodeLocation = '';
      return next;
    });
  };

  const changerType = (e) => {
    const type = e.target.value;
    const next = {
      ...filtres,
      type,
      ...(type === 'terrain' ? { typeLogement: '', chambresMin: '' } : {}),
      ...(type !== 'location' ? { periodeLocation: '' } : {}),
    };
    setFiltres(next);
    onFiltrer(next);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFiltrer(filtres);
  };

  const handleReset = () => {
    setFiltres(VIDE);
    onFiltrer(VIDE);
  };

  const appliquerRaccourci = (patch) => {
    setFiltres(prev => {
      const next = { ...prev, ...patch };
      if (patch.ville !== undefined) {
        next.commune = patch.commune || '';
        next.quartier = patch.quartier || '';
      }
      if (next.type === 'terrain') next.typeLogement = '';
      if (next.type !== 'location') next.periodeLocation = '';
      onFiltrer(next);
      return next;
    });
  };

  const raccourciActif = (patch) => {
    return Object.entries(patch).every(([key, value]) => filtres[key] === value);
  };

  const nbActifs = Object.entries(filtres)
    .filter(([k, v]) => v !== '' && !(k === 'tri' && v === 'recent'))
    .length;

  const communes = getSousPrefectures(filtres.ville);
  const quartiers = getQuartiers(filtres.ville, filtres.commune);

  return (
    <form className="filterbar" onSubmit={handleSubmit}>
      <div className="filterbar-row">
        <div className="filterbar-group">
          <label htmlFor="filter-type">Type de bien</label>
          <select id="filter-type" name="type" value={filtres.type} onChange={changerType}>
            <option value="">Tous les types</option>
            <option value="location">Location</option>
            <option value="vente-maison">Vente maison</option>
            <option value="terrain">Terrain</option>
          </select>
        </div>

        <div className="filterbar-divider" />

        <div className="filterbar-group">
          <label htmlFor="filter-ville">Préfecture</label>
          <select id="filter-ville" name="ville" value={filtres.ville} onChange={set('ville')}>
            <option value="">Toutes les préfectures</option>
            {PREFECTURES.map(v => <option key={v} value={v}>{v}</option>)}
          </select>
        </div>

        {filtres.ville && communes.length > 0 && (
          <div className="filterbar-group">
            <label htmlFor="filter-commune">{filtres.ville === 'Conakry' ? 'Commune' : 'Sous-préfecture'}</label>
            <select id="filter-commune" name="commune" value={filtres.commune} onChange={set('commune')}>
              <option value="">Toutes</option>
              {communes.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        )}

        <div className="filterbar-divider" />

        {filtres.type === 'location' && (
          <div className="filterbar-group">
            <label htmlFor="filter-periode-location">Période</label>
            <select id="filter-periode-location" name="periodeLocation" value={filtres.periodeLocation} onChange={set('periodeLocation')}>
              <option value="">Toutes</option>
              <option value="jour">Par jour</option>
              <option value="semaine">Par semaine</option>
              <option value="mois">Par mois</option>
            </select>
          </div>
        )}

        <div className="filterbar-group">
          <label htmlFor="filter-tri">Trier par</label>
          <select id="filter-tri" name="tri" value={filtres.tri} onChange={set('tri')}>
            {TRI_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>

        <div className="filterbar-group filterbar-group--prix">
          <span className="filterbar-label">Prix (GNF)</span>
          <div className="prix-range">
            <input id="filter-prix-min" name="prixMin" type="number" placeholder="Min" value={filtres.prixMin} onChange={set('prixMin')} min="0" />
            <span className="prix-sep">-</span>
            <input id="filter-prix-max" name="prixMax" type="number" placeholder="Max" value={filtres.prixMax} onChange={set('prixMax')} min="0" />
          </div>
        </div>

        <div className="filterbar-actions">
          <button type="submit" className="btn btn-primary">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            Rechercher
          </button>

          <button
            type="button"
            className={`btn btn-outline-filter ${ouvert ? 'actif' : ''}`}
            onClick={() => setOuvert(o => !o)}
            title="Filtres avancés"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/>
            </svg>
            Filtres
            {nbActifs > 0 && <span className="filtre-badge">{nbActifs}</span>}
          </button>

          {nbActifs > 0 && (
            <button type="button" className="btn btn-ghost" onClick={handleReset} title="Effacer les filtres">
              x
            </button>
          )}
        </div>
      </div>

      <div className="filterbar-quick">
        <span>Raccourcis</span>
        <button
          type="button"
          className={raccourciActif({ type: 'location', periodeLocation: 'mois' }) ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ type: 'location', periodeLocation: 'mois', typeLogement: '', tri: 'recent' })}
        >
          Location/mois
        </button>
        <button
          type="button"
          className={raccourciActif({ type: 'location', periodeLocation: 'jour' }) ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ type: 'location', periodeLocation: 'jour', typeLogement: '', tri: 'recent' })}
        >
          Courte durée
        </button>
        <button
          type="button"
          className={raccourciActif({ type: 'vente-maison' }) ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ type: 'vente-maison', typeLogement: '', periodeLocation: '', tri: 'recent' })}
        >
          Maisons/villas
        </button>
        <button
          type="button"
          className={raccourciActif({ type: 'terrain' }) ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ type: 'terrain', typeLogement: '', periodeLocation: '', chambresMin: '', tri: 'recent' })}
        >
          Terrains
        </button>
        <button
          type="button"
          className={raccourciActif({ ville: 'Conakry', commune: '', quartier: '' }) ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ ville: 'Conakry', commune: '', quartier: '' })}
        >
          Conakry
        </button>
        <button
          type="button"
          className={raccourciActif({ verifie: 'true', photosOnly: 'true' }) ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ verifie: 'true', photosOnly: 'true', tri: 'recent' })}
        >
          Diaspora
        </button>
        <button
          type="button"
          className={filtres.photosOnly === 'true' ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ photosOnly: filtres.photosOnly === 'true' ? '' : 'true' })}
        >
          Avec photos
        </button>
        <button
          type="button"
          className={filtres.verifie === 'true' ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ verifie: filtres.verifie === 'true' ? '' : 'true' })}
        >
          Vérifiées
        </button>
        <button
          type="button"
          className={filtres.negotiable === 'true' ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ negotiable: filtres.negotiable === 'true' ? '' : 'true' })}
        >
          Prix négociable
        </button>
        <button
          type="button"
          className={filtres.chambresMin === '3' ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ chambresMin: filtres.chambresMin === '3' ? '' : '3' })}
          disabled={filtres.type === 'terrain'}
        >
          3+ chambres
        </button>
        <button
          type="button"
          className={filtres.tri === 'prix_asc' ? 'actif' : ''}
          onClick={() => appliquerRaccourci({ tri: filtres.tri === 'prix_asc' ? 'recent' : 'prix_asc' })}
        >
          Moins cher
        </button>
      </div>

      {ouvert && (
        <div className="filterbar-avances">
          <div className="filterbar-avances-grid">
            <div className="filterbar-group">
              <label htmlFor="filter-quartier">Quartier / zone</label>
              {quartiers.length > 0 ? (
                <select id="filter-quartier" name="quartier" value={filtres.quartier} onChange={set('quartier')}>
                  <option value="">Tous les quartiers</option>
                  {quartiers.map(q => <option key={q} value={q}>{q}</option>)}
                  <option value="Autre">Autre</option>
                </select>
              ) : (
                <input id="filter-quartier" name="quartier" placeholder="Ex: Kipé, Ratoma, Centre..." value={filtres.quartier} onChange={set('quartier')} />
              )}
            </div>

            <div className="filterbar-group">
              <label htmlFor="filter-type-logement">Type de logement</label>
              <select id="filter-type-logement" name="typeLogement" value={filtres.typeLogement} onChange={set('typeLogement')} disabled={filtres.type === 'terrain'}>
                <option value="">Tous</option>
                {TYPE_LOGEMENT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>

            <div className="filterbar-group">
              <label htmlFor="filter-chambres-min">Chambres minimum</label>
              <select id="filter-chambres-min" name="chambresMin" value={filtres.chambresMin} onChange={set('chambresMin')}>
                <option value="">Peu importe</option>
                <option value="1">1+ chambre</option>
                <option value="2">2+ chambres</option>
                <option value="3">3+ chambres</option>
                <option value="4">4+ chambres</option>
                <option value="5">5+ chambres</option>
              </select>
            </div>

            <div className="filterbar-group">
              <span className="filterbar-label">Surface habitable (m²)</span>
              <div className="prix-range">
                <input id="filter-surface-min" name="surfaceMin" type="number" placeholder="Min" value={filtres.surfaceMin} onChange={set('surfaceMin')} min="0" />
                <span className="prix-sep">-</span>
                <input id="filter-surface-max" name="surfaceMax" type="number" placeholder="Max" value={filtres.surfaceMax} onChange={set('surfaceMax')} min="0" />
              </div>
            </div>

            <div className="filterbar-group">
              <span className="filterbar-label">Surface terrain (m²)</span>
              <div className="prix-range">
                <input id="filter-surface-terrain-min" name="surfaceTerrainMin" type="number" placeholder="Min" value={filtres.surfaceTerrainMin} onChange={set('surfaceTerrainMin')} min="0" />
                <span className="prix-sep">-</span>
                <input id="filter-surface-terrain-max" name="surfaceTerrainMax" type="number" placeholder="Max" value={filtres.surfaceTerrainMax} onChange={set('surfaceTerrainMax')} min="0" />
              </div>
            </div>

            <div className="filterbar-group">
              <label htmlFor="filter-etat">État du bien</label>
              <select id="filter-etat" name="etat" value={filtres.etat} onChange={set('etat')}>
                <option value="">Tous les états</option>
                {ETAT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>

            <ToggleFilter
              label="Prix négociable"
              checked={filtres.negotiable === 'true'}
              onChange={checked => setFiltres(prev => ({ ...prev, negotiable: checked ? 'true' : '' }))}
            />
            <ToggleFilter
              label="Annonce vérifiée"
              checked={filtres.verifie === 'true'}
              onChange={checked => setFiltres(prev => ({ ...prev, verifie: checked ? 'true' : '' }))}
            />
            <ToggleFilter
              label="Avec photos"
              checked={filtres.photosOnly === 'true'}
              onChange={checked => setFiltres(prev => ({ ...prev, photosOnly: checked ? 'true' : '' }))}
            />
          </div>
        </div>
      )}
    </form>
  );
}

function ToggleFilter({ label, checked, onChange }) {
  const id = `filter-${label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-')}`;

  return (
    <div className="filterbar-group filterbar-group--check">
      <label htmlFor={id}>{label}</label>
      <label className="toggle-check">
        <input id={id} name={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} />
        <span className="toggle-slider" />
        <span className="toggle-label">{checked ? 'Oui' : 'Indifférent'}</span>
      </label>
    </div>
  );
}
